// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_qNAeG","middle":"middle_kJQsm"};